import React from 'react';
import PropTypes from 'prop-types';

import FileUploadIcon from '@mui/icons-material/FileUpload';
import { Tooltip } from '@mui/material';

import icon from './iconStyles.module.css';

const OnFileUploadIcon = ({ onUpload, active = true }) => {
    return (
        <div
            role="button"
            tabIndex={active ? 0 : -1}
            aria-disabled={!active}
            className={`${icon.uploadIcon} ${!active ? icon.disabled : ''}`}
            onClick={() => active && onUpload()}
            onKeyDown={(e) => active && (e.key === 'Enter' || e.key === ' ') && onUpload()}
            data-testid="upload_icon_wrapper">
            <Tooltip title="Upload" placement="top" disableHoverListener={!active}>
                <FileUploadIcon aria-label="file-upload-icon" data-testid="file-upload-icon" />
            </Tooltip>
        </div>
    );
};

OnFileUploadIcon.propTypes = {
    active: PropTypes.bool,
    onUpload: PropTypes.func
};

export default OnFileUploadIcon;
